import './src/lib/supabase-lock-patch';
import React from 'react';
import 'katex/dist/katex.min.css';
import { CartProvider } from './src/lib/shop/CartContext';
import { FlashPromoProvider } from './src/lib/shop/FlashPromoContext';
import { PricingProvider } from './src/lib/shop/PricingContext';
import { RegionProvider } from './src/lib/shop/RegionContext';
import { purgeStaleSupabaseClient } from './src/lib/supabase';

export const wrapRootElement = ({ element }) => (
  <PricingProvider>
    <RegionProvider>
      <FlashPromoProvider>
        <CartProvider>{element}</CartProvider>
      </FlashPromoProvider>
    </RegionProvider>
  </PricingProvider>
);

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  // Drop any client created by an older bundle that still uses Navigator LockManager.
  purgeStaleSupabaseClient();

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = typeof reason?.message === 'string' ? reason.message : '';

    if (
      reason?.isAcquireTimeout ||
      message.includes('Navigator LockManager lock "lock:sb-')
    ) {
      event.preventDefault();
    }
  });
};
